import React, { useEffect } from "react";
import PropTypes from "prop-types";

export const AppleLogin = ({ onSuccess, onFailure, children, appleClientId, appleRedirectUri }) => {
  const initApple = async () =>
    await window.AppleID.auth.init({
      clientId: appleClientId,
      redirectURI: appleRedirectUri,
      scope: "name email",
      usePopup: true,
      state: ((Math.random() * 0xffffff) << 0).toString(8)
    });

  const signInApple = async () => {
    try {
      const response = await window.AppleID.auth.signIn();
      const { code, id_token } = response.authorization;
      onSuccess({ code, id_token });
    } catch (e) {
      onFailure(e);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      await initApple()
    };

    initialize();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <span style={{ display: "inline-block" }} onClick={() => signInApple()}>
      {children}
    </span>
  );
};

AppleLogin.propTypes = {
  onFailure: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  appleClientId: PropTypes.string.isRequired,
  appleRedirectUri: PropTypes.string.isRequired
};

AppleLogin.defaultProps = {};
